export class User {
    public user: number;
    public hotel: string;
    public lastname: string;
    public firstname: string;
    public email: string;
    public password: string;
    public level: number;
    public indblock: boolean;
    public datcre: Date;
    public datlastlogin: Date;
    public lang: string;
    public comment: string;

    constructor() {
    }
}
